<script>
    import { onMount, onDestroy } from 'svelte';
    
    let navHeight=0;

    import "ol/ol.css";  // Import OpenLayers CSS
    import Map from "ol/Map";
    import View from "ol/View";
    import TileLayer from "ol/layer/Tile";
    import Image from "ol/layer/Image";

    import OSM from "ol/source/OSM";
    import TileWMS from "ol/source/TileWMS";
    import TileArcGISRest from "ol/source/TileArcGISRest";
    import ImageArcGISRest from "ol/source/ImageArcGISRest";
    import ImageWMS from "ol/source/ImageWMS";
 

    import { boundingExtent } from 'ol/extent';  // Import boundingExtent
    import { fromLonLat } from "ol/proj";
    import TabsContent from '../partials/map_viewer/TabsContent.svelte';
    import { Icon, ArrowDownTray, SquaresPlus } from "svelte-hero-icons";

    let map; // Reference for the map
    let isLayDetailCollapse=true;
    let currentLayer = "";

    // Function to handle toggle logic
    function toggleLayDetail(event) {
        const lay= event.detail;
        if (currentLayer === lay) {
            isLayDetailCollapse = !isLayDetailCollapse;
        } else {
            isLayDetailCollapse = false;
            currentLayer = lay;
        }
        // console.log("isLayDetailCollapse:", isLayDetailCollapse);
        // console.log("currentLayerTitle:", currentLayer);
        
    }
    // $: console.log("Reactive state: ", isLayDetailCollapse, currentLayer);
    
    // Handle click outside to collapse the container
    function handleClickOutside(event) {
        // const detailContainer = document.querySelector("#layer-detail-container");
        // if (detailContainer && !detailContainer.contains(event.target)) {
        //     isLayDetailCollapse = true;
        // }
        const detailContainer = document.querySelector("#layer-detail-container");
        const tabButtons = document.querySelectorAll(".btnLayDetail");

        // Check if the click is outside the layer detail container
        const isOutsideContainer = !detailContainer?.contains(event.target);

        // Check if the click is on one of the buttons
        const isOnTabButton = Array.from(tabButtons).some(button => button.contains(event.target));

        if (isOutsideContainer && !isOnTabButton) {
            isLayDetailCollapse = true;
        }
    }

    function adjustHeight(){
        // navHeight=121;
        navHeight=document.getElementById('nav-section').getBoundingClientRect().height;
    }

    // Convert to Web Mercator projection (EPSG:3857)
    var olExtent = [
        ...fromLonLat([79.0601478269608, 26.2474236433865]),  // lower-left
        ...fromLonLat([88.2042985211598, 30.5473263959965])   // upper-right
    ];

    var lcLayer =new Image({
          visible: true, // Set to true to make it visible
          source: new ImageArcGISRest({
            url: 'https://geoapps.icimod.org/icimodarcgis/rest/services/HKH/Landcover/MapServer',
            layerIds: [0], // Layer index 0 from the ArcGIS MapServer
            crossOrigin: 'anonymous'
          })
        });

    function reorderLayers(event){
        // console.log("reorderLayers triggered:", event.detail);
        const { layer, fromIndex, toIndex } = event.detail;
        const allLayers = map.getLayers();
        if (layer && layer.layer) {
            
            if (fromIndex > -1 && toIndex >= 0 && toIndex < allLayers.getLength()) {
                allLayers.remove(layer.layer); // Remove the layer from its current position
                allLayers.insertAt(toIndex, layer.layer); // Insert the layer at the new position
            }
        }
    }

    function opacityChange(event){
        // console.log("opacityChange triggered:", event.detail);
        const { layer, opacity }= event.detail;
        if (layer && layer.layer) {
            layer.layer.setOpacity(opacity);
        }
        // console.log("opacityChange:", lay);
    }

    function addLayerToMap(event){
        const lay= event.detail;
        if (!lay) return;

        if(lay.mapServiceURL === ''){
            return;
        }
        
        if (!lay.added){
            map.getLayers().remove(lay.layer);
            // lay.added = false;
        }else{
            let newLayer;

            if(lay.mapServer == 'arcgis'){
                newLayer = new Image({
                    visible: true, // Set to true to make it visible
                    source: new ImageArcGISRest({
                        url: lay.mapServiceURL,
                        // layers: `show:${lay.layerIndex}`,
                        crossOrigin: 'anonymous',
                        params: {
                            LAYERS: `show:${lay.layerIndex}`,
                            FORMAT: "image/png"
                        }
                    })
                });
            }
            else if(lay.mapServer == 'geoserver'){
                newLayer = new Image({
                    visible: true, // Set to true to make it visible
                    source: new ImageWMS({
                        url: lay.mapServiceURL,
                        params: {
                          'FORMAT': 'image/png',
                          'VERSION': '1.1.1',
                          "LAYERS": lay.layerIndex, // Dynamically using mapid
                          "exceptions": 'application/vnd.ogc.se_inimage'
                        },
                        crossOrigin: 'anonymous'
                      })
                });
            }

            map.addLayer(newLayer);
            // map.getLayers().insertAt(1, newLayer);
            lay.layer = newLayer; // Save the layer instance
            // lay.added = true; 
        }
    }

    function createMap(){
        map = new Map({
            target: "map", // ID of the HTML element
            layers: [
                new TileLayer({
                    source: new OSM(), // OpenStreetMap as the tile source
                }),
                // lcLayer,
            ],
            view: new View({
                // center: fromLonLat([84.124, 28.3949]), // Center of Nepal (approximately)
                // zoom: 7,  // Adjust zoom level to fit the extent
                center: fromLonLat([82.9492797851563, 27.6383056640625]),
                zoom: 4
            }),
        });

        zoomExtent();
    }

    function zoomExtent(){
        var _lowerLeft = fromLonLat([60.85388183593756, 13.9578857421875]);
        var _upperRight = fromLonLat([105.04467773437506, 41.3187255859375]);
        var ext = boundingExtent([_lowerLeft, _upperRight]);
        // ext = ol.proj.transformExtent(ext, ol.proj.get('EPSG:4326'), ol.proj.get('EPSG:3857'));

        map.getView().fit(ext, {
            size: map.getSize(),
            duration: 200
        });
        
    }

    onMount(()=>{
     
        adjustHeight();  // Calculate navHeight when component is mounted
        createMap();
        document.addEventListener("click", handleClickOutside);
        window.addEventListener('resize', adjustHeight);  // Update navHeight on window resize

        return () => {
            map.setTarget(null); // Cleanup when the component is destroyed
            window.removeEventListener('resize', adjustHeight);  // Remove event listener
            document.removeEventListener("click", handleClickOutside);
        };
    });

     
</script>

<!-- Position nav at the top -->

 
<!-- <aside class="w-96 flex-shrink-0 lg:flex flex-col bg-slate-200 text-gray-500 h-full overflow-auto hidden shadow">
    <div class="p-4 text-2xl font-bold">
        select
    </div>
</aside>

<div class="flex flex-col flex-grow h-full overflow-hidden bg-gray-900">
    <p>Map Viewer</p>
</div> -->

<div id="nav-section" class="flex flex-grow bg-white pl-5">
    <!-- Title -->
    <!-- <aside class="w-96 flex-shrink-0  text-gray-700 overflow-hidden ">
      <div class="p-2 text-2xl">
        RIS Map Viewer
      </div>
    </aside> -->

    <!-- Nav bar -->
    <!-- <div class="flex-grow text-gray-500 overflow-hidden ml-5">
        <Nav className="p-2 pl-0" />
    </div> -->
</div>

<!-- Content below the nav -->
<div style="height: calc(100% - {navHeight}px)" class="flex bg-white p-5 ">
    <!-- Sidebar (aside) -->
    <aside class="w-96 flex-shrink-0 bg-gray-100 text-gray-500 overflow-hidden drop-shadow-lg">
        <!-- style="background-color: #F7F9FB;" -->
       
         

        <TabsContent
         on:toggle={(event) => toggleLayDetail(event)} 
         on:addToMap={(event) => addLayerToMap(event)} 
         on:opacityChange={(event) => opacityChange(event)}
         on:reorderLayers={(event) => reorderLayers(event)}
         />
    </aside>

    <!-- Map Viewer -->
    <div id="map" class="flex-grow bg-gray-100 text-gray-800 overflow-hidden h-full ml-5 drop-shadow-lg">
        <div 
            id="layer-detail-container"
            class="flex w-full z-10 bottom-0 left-0  bg-gray-50 absolute transition-all duration-300
            {isLayDetailCollapse?'h-0':' h-2/6'}
        ">
            <div class="p-4 w-full flex flex-col">
                <h3 class="text-lg font-semibold sticky top-0 bg-gray-50">{currentLayer.title}</h3>
                <div class="flex-1 overflow-y-auto mt-2">
                    <p>{currentLayer.description}</p>
                    
                    {#if currentLayer.rdsURL}
                        <a href={currentLayer.rdsURL} target="_blank"
                            class="flex items-center gap-2 text-blue-600 hover:text-blue-800 mt-2">
                            <Icon src={ArrowDownTray} size="16"/>
                            {currentLayer.rdsURL}
                        </a>
                    {/if}
                    
                    {#if currentLayer.appURL}
                        <a href={currentLayer.appURL} target="_blank"
                        class="flex items-center gap-2 text-blue-600 hover:text-blue-800 mt-2">
                            <Icon src={SquaresPlus} size="16"/>
                            {currentLayer.appURL}
                        </a>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>
